import type { ComponentProps } from 'react';
import React from 'react';

import type { Nullable } from 'corgi-types';
import CommonUspTeaser from 'corgi/common-usp-teaser/components/CommonUspTeaser';
import FooterLegalText from 'corgi/footer-legal-text/components/FooterLegalText';
import FooterLinkSection from 'corgi/footer-link-section/components/FooterLinkSection';
import TrustSeals from 'corgi/trust-seals/components/TrustSeals';
import type { GlobalNavigationProps } from 'frontend-utils/global-nav';

import { arePropsNonEmpty } from '@utils/render';

type FooterProps = GlobalNavigationProps & {
  uspTeaserProps?: Nullable<ComponentProps<typeof CommonUspTeaser>>;
};

const Footer = ({ footer, trustSeals, uspTeaserProps }: FooterProps) => {
  const { legalText, ...footerProps } = footer ?? {};

  return (
    <footer>
      {arePropsNonEmpty(uspTeaserProps) && <CommonUspTeaser {...uspTeaserProps} />}
      {footerProps && <FooterLinkSection {...footerProps} />}
      {arePropsNonEmpty(trustSeals) && <TrustSeals {...trustSeals} />}
      {legalText && <FooterLegalText legalText={legalText} />}
    </footer>
  );
};

export default Footer;
